import React from "react";
import "./home.css";
import useAuth from "../../../hooks/useAuth";
import Members from "../members_container/Members";
import MemberProfile from "../members_container/memberDetails/memberprofile/MemberProfiles";
import SavingsContainer from "../members_container/memberDetails/savingscontainer/SavingsContainer";
import LoanContainer from "../members_container/memberDetails/loancontainer/LoanContainer";
import RepaymentContainer from "../members_container/memberDetails/repaymentcontainer/RepaymentContainer";
import { Route, Routes } from "react-router-dom";
import { Layout } from "../../../shared/Layout";
import ExploreContainer from "../explore_container/ExploreContainer";
import Notfound from "../../../shared/notfound/Notfound";
import Notifications from "../notifications/Notifications";
import Documents from "../documents/Documents";
import Vouchers from "../vouchers/Vouchers";
import Applyloans from "../applyloans/Applyloans";
import InterestRecord from "../interestrecord/InterestRecord";
import { DepositDetail, DepositForm, DepositInterestByMember, DepositsList } from "../pages/deposits/Deposits";
import TakePayments from "../takepayments/TakePayments";
import Invoices from "../invoices/Invoices";
import Settings from "../settings/Settings";
import Dashboard from "../pages/dashboard/Dashboard";
import { BillingOverview, BillingSettings, ChangePlan, PlanInvoice } from "../pages/billing/Billing";
import { RoleDetail, Roles } from "../pages/roles/Roles";
import { Jobs, Reports } from "../pages/admin/Admin";
import {
  DeleteAccountPage,
  InvoiceDetail,
  LoanApplicationDetail,
  LoanDetail,
  PaymentDetail,
  PaymentsList,
  RecordDetail,
} from "../pages/records/Records";
import { Loading } from "../../../shared/ui/ui";

/** The frame every page sits in. */
const Frame = ({ children }) => (
  <div className="home">
    <div className="home-wrapper">
      <section className="home-content home-fillcontent">{children}</section>
    </div>
  </div>
);

function Home() {
  const { auth, access } = useAuth();

  // Every page decides what to show from what this person may do, and most
  // fetch on first render — so nothing renders until that answer is in. A
  // page drawn before it would show a member's view to an administrator.
  if (!access.loaded) {
    return (
      <Frame>
        <Loading />
      </Frame>
    );
  }

  const page = (element) => <Frame>{element}</Frame>;

  return (
    <>
      <Routes>
        <Route path="admin/*" element={<Layout />}>
          <Route path="home" element={page(<Dashboard />)} />
          <Route path="members" element={<Members />} />
          <Route
            path="profile"
            element={
              <div className="home">
                <div className="home-wrapper">
                  <div className="home-header">
                    <div className="home-headerleft">
                      <h3 className="home-heading">Profile</h3>
                    </div>
                  </div>
                  <section className="home-content">
                    <MemberProfile selectedMember={auth.user} page="profile" />
                  </section>
                </div>
              </div>
            }
          />
          <Route path="explore" element={page(<ExploreContainer selectedMember={auth.user} />)} />
          <Route path="save" element={page(<SavingsContainer selectedMember={auth.user} />)} />
          <Route path="docs" element={page(<Documents selectedMember={auth.user} />)} />
          <Route path="loans" element={page(<LoanContainer selectedMember={auth.user} />)} />
          <Route path="loans/:loanId" element={page(<LoanDetail />)} />
          <Route path="repayment" element={page(<RepaymentContainer selectedMember={auth.user} />)} />
          <Route path="take-payment" element={page(<TakePayments selectedMember={auth.user} />)} />
          <Route path="notifications" element={page(<Notifications selectedMember={auth.user} />)} />
          <Route path="vouchers" element={page(<Vouchers selectedMember={auth.user} />)} />
          <Route path="applyloans" element={page(<Applyloans selectedMember={auth.user} />)} />
          <Route path="applyloans/:formId" element={page(<LoanApplicationDetail />)} />
          <Route path="interestrecord" element={page(<InterestRecord selectedMember={auth.user} />)} />
          <Route path="records/:kind/:recordId" element={page(<RecordDetail />)} />
          <Route path="fixed-deposits" element={page(<DepositsList />)} />
          <Route path="fixed-deposits/new" element={page(<DepositForm />)} />
          <Route path="fixed-deposits/interest" element={page(<DepositInterestByMember />)} />
          <Route path="fixed-deposits/:depositId" element={page(<DepositDetail />)} />
          <Route path="fixed-deposits/:depositId/edit" element={page(<DepositForm />)} />
          <Route path="recurring-deposits" element={page(<DepositsList recurring />)} />
          <Route path="recurring-deposits/new" element={page(<DepositForm recurring />)} />
          <Route path="recurring-deposits/interest" element={page(<DepositInterestByMember recurring />)} />
          <Route path="recurring-deposits/:depositId" element={page(<DepositDetail recurring />)} />
          <Route path="recurring-deposits/:depositId/edit" element={page(<DepositForm recurring />)} />
          <Route path="payments" element={page(<PaymentsList />)} />
          <Route path="payments/:paymentId" element={page(<PaymentDetail />)} />
          <Route path="invoices" element={page(<Invoices selectedMember={auth.user} />)} />
          <Route path="invoices/:invoiceId" element={page(<InvoiceDetail />)} />
          <Route path="jobs" element={page(<Jobs />)} />
          <Route path="reports" element={page(<Reports />)} />
          <Route path="settings" element={page(<Settings />)} />
          <Route path="billing" element={page(<BillingOverview />)} />
          <Route path="billing/plans" element={page(<ChangePlan />)} />
          <Route path="billing/settings" element={page(<BillingSettings />)} />
          <Route path="billing/invoices/:invoiceId" element={page(<PlanInvoice />)} />
          <Route path="roles" element={page(<Roles />)} />
          <Route path="roles/:roleKey" element={page(<RoleDetail />)} />
          <Route path="delete-account" element={page(<DeleteAccountPage />)} />
        </Route>
        <Route path="*" element={<Notfound />}></Route>
      </Routes>
    </>
  );
}

export default Home;
